module.exports = __webpack_public_path__ + "static/4-757909f83d5d9f2be846b540196ebd24.jpg";